export const parsePreviousAnswers = (
  text: string,
  previousAnswers: Record<
    string,
    { value: string | string[]; displayAs?: string }
  >,
): string => {
  // Use regex to find all variables in the format {{any_name}}
  return (
    text?.replace(/{{(.*?)}}/g, (_, variable) => {
      const value = previousAnswers[variable]?.value;
      const displayAs = previousAnswers[variable]?.displayAs;

      if (displayAs) {
        return displayAs;
      }

      if (Array.isArray(value)) {
        return value.join(", ");
      }

      return value || "";
    }) || ""
  );
};
